import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root'
})
export class ArchiveService {

  public mtds: Methods = new Methods();
  public url: string;
  public urlUser: string;
  public token;
  public headers;
  public identity;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url;
  
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  archiveBulk(bulk: Array<any> = [], status = 'all'): Observable<any> {
    this.identity = this.getIdentity();
    const userId = this.identity.sub;
    const json = {
      bulk,
      userId,
      status
    };
    return this.petition(`${this.url}/folderarchive/bulk`, json);
  }

  getToken(): string {
  return JSON.parse(localStorage.getItem('token'));
}

getIdentity(): any {
  return JSON.parse(localStorage.getItem('identity'));
}


  getFolders(page = 1, perPage = 10, busqueda = "", filtros = [], idFolder = 0): Observable<any> {
    this.token = this.getToken();
    const headers = this.createHeaders();

    let url;
    
    url = `${this.url}/folderarchive/listbyuser?idFolder=${idFolder}&`;

    let json = null;
    if (busqueda === "") {
      json = {
        busqueda: "busqueda",
      };
    }


    json = JSON.stringify(json);

    const params = {
      json: encodeURIComponent(json),
      authorization: this.token
    };

    url = url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this._http.post<any>(
      url,
      this.buildSearchParams(params),
      { headers }
    );

    //return this.petition(`${this.url}/folderarchive/listbyuser?page=1&perpage=100000000000`);
  }

  petition(url: string, json: any = null, type: string = null): Observable<any> {

    this.token = this.getToken();
    
    let paramas;
    paramas = `authorization=${this.token}`;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      paramas = `${paramas}&json=${json}`;
    }

    if (type != null) {
      paramas = `${paramas}&type=${type}`;
    }

    return this._http.post(url, paramas, { headers: this.headers }).pipe(
      map((res: any) => res),
      map(response => {
        if (response.code === 404) {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        }
        return response;
      })
    );
  }

  private createHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  private buildSearchParams(params: any): any {
    return Object.keys(params)
      .map(key => `${key}=${params[key]}`)
      .join('&');
  }
}
